import { toast } from '@components/ui/use-toast';

export const copyToClipboard = async (sku: string, title: string, description: string) => {
  await navigator.clipboard.writeText(sku);
  toast({
    title,
    description,
  });
};
